import { useState } from 'react';
import { useCarrierSettingsCache } from 'shared/settings/CarrierSettingsAPI';
import { InstantTransferReminderContent } from './InstantTransferReminderDialog';
import { InstantTransferReminderReasonCloseContent } from './InstantTransferReasonCloseDialog';
import { Dialog } from '@material-ui/core';

interface InstantTransferReminderDialogsContentProps {
  onClose: () => void;
}

function InstantTransferReminderDialogsContent({
  onClose,
}: InstantTransferReminderDialogsContentProps) {
  const { invalidateCarrierSettings } = useCarrierSettingsCache();
  const [isOpenReasonDialog, setOpenReasonDialog] = useState(false);

  return isOpenReasonDialog ? (
    <InstantTransferReminderReasonCloseContent
      onClose={() => {
        setOpenReasonDialog(false);
        invalidateCarrierSettings();
        onClose();
      }}
    />
  ) : (
    <InstantTransferReminderContent
      onClose={onClose}
      onAlwaysClosed={() => {
        setOpenReasonDialog(true);
      }}
    />
  );
}

interface InstantTransferReminderDialogsProps {
  onClose: () => void;
  isOpen: boolean;
}

export function InstantTransferReminderDialogs({
  isOpen,
  onClose,
}: InstantTransferReminderDialogsProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth={true}>
      <InstantTransferReminderDialogsContent onClose={onClose} />
    </Dialog>
  );
}
